"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLastVesselActivityEndDate = exports.findAllVesselActivitiesEndDate = exports.SortVesselActivities = exports.findVesselActivityEndDate = exports.findVesselActivityStartDate = void 0;
const moment_1 = __importDefault(require("moment"));
const shared_1 = require("../proto/shared");
function findVesselActivityStartDate(activity) {
    return moment_1.default(activity.startDate);
}
exports.findVesselActivityStartDate = findVesselActivityStartDate;
function findVesselActivityEndDate(activity) {
    return moment_1.default(activity.endDate);
}
exports.findVesselActivityEndDate = findVesselActivityEndDate;
function SortVesselActivities(vesselActivities) {
    return Object.values(vesselActivities).sort((va, vb) => {
        const ma = moment_1.default(va.startDate);
        const mb = moment_1.default(vb.startDate);
        if (ma && mb) {
            const isAfter = ma.isBefore(mb);
            const isEqual = ma.isSame(mb, 'minute');
            if (isAfter) {
                return -1;
            }
            else if (isEqual) {
                return 0;
            }
            else {
                return 1;
            }
        }
        else {
            throw new Error('a sortVessel date is undefined');
        }
    });
}
exports.SortVesselActivities = SortVesselActivities;
function SortAllVesselActivitiesByEndDate(vesselActivities) {
    return Object.values(vesselActivities).sort((va, vb) => {
        const ma = moment_1.default(va.endDate);
        const mb = moment_1.default(vb.endDate);
        if (ma && mb) {
            const isAfter = ma.isBefore(mb);
            const isEqual = ma.isSame(mb, 'minute');
            if (isAfter) {
                return -1;
            }
            else if (isEqual) {
                return 0;
            }
            else {
                return 1;
            }
        }
        else {
            throw new Error('a sortVesselByEndDate date is undefined');
        }
    });
}
function findAllVesselActivitiesEndDate(vessel) {
    var _a, _b;
    const vesselActivities = SortAllVesselActivitiesByEndDate(vessel.activities);
    const lastActivity = vesselActivities[vesselActivities.length - 1];
    return (_b = (_a = lastActivity === null || lastActivity === void 0 ? void 0 : lastActivity.endDate) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : '';
}
exports.findAllVesselActivitiesEndDate = findAllVesselActivitiesEndDate;
function getLastVesselActivityEndDate(activities, shiploader) {
    var _a, _b, _c, _d;
    const shiploader1 = {};
    const shiploader2 = {};
    //TODO
    Object.entries(activities).forEach((itm) => {
        const [key, vesselActivity] = itm;
        const { vesselHatchActivityGroup, nonHatchAwaitingShiploaderActivity, nonHatchBreakdownActivity, nonHatchReclaimingActivity, nonHatchShiftingActivity, nonHatchTnpaActivity, singleLoadingActivity, stopVesselActivity, surveyActivity, shiploader, } = vesselActivity;
        if (vesselHatchActivityGroup) {
            //Shiploader specific
            const Item = vesselActivity;
            if (shiploader === shared_1.Shiploader.SHIPLOADER_ONE) {
                shiploader1[key] = Item;
            }
            if (shiploader === shared_1.Shiploader.SHIPLOADER_TWO) {
                shiploader2[key] = Item;
            }
        }
        if (nonHatchAwaitingShiploaderActivity) {
            //This is shiploader specific
            const Item = vesselActivity;
            if (shiploader === shared_1.Shiploader.SHIPLOADER_ONE) {
                shiploader1[key] = Item;
            }
            if (shiploader === shared_1.Shiploader.SHIPLOADER_TWO) {
                shiploader2[key] = Item;
            }
        }
        if (nonHatchBreakdownActivity) {
            //This is shiploader specific
            const Item = vesselActivity;
            if (shiploader === shared_1.Shiploader.SHIPLOADER_ONE) {
                shiploader1[key] = Item;
            }
            if (shiploader === shared_1.Shiploader.SHIPLOADER_TWO) {
                shiploader2[key] = Item;
            }
        }
        if (nonHatchReclaimingActivity) {
            //This is shiploader specific
            const Item = vesselActivity;
            if (shiploader === shared_1.Shiploader.SHIPLOADER_ONE) {
                shiploader1[key] = Item;
            }
            if (shiploader === shared_1.Shiploader.SHIPLOADER_TWO) {
                shiploader2[key] = Item;
            }
        }
        if (nonHatchShiftingActivity) {
            //This is shiploader specific
            const Item = vesselActivity;
            if (shiploader === shared_1.Shiploader.SHIPLOADER_ONE) {
                shiploader1[key] = Item;
            }
            if (shiploader === shared_1.Shiploader.SHIPLOADER_TWO) {
                shiploader2[key] = Item;
            }
        }
        if (nonHatchTnpaActivity) {
            //This is shiploader specific
            const Item = vesselActivity;
            if (shiploader === shared_1.Shiploader.SHIPLOADER_ONE) {
                shiploader1[key] = Item;
            }
            if (shiploader === shared_1.Shiploader.SHIPLOADER_TWO) {
                shiploader2[key] = Item;
            }
        }
        if (singleLoadingActivity) {
            //This is shiploader specific
            const Item = vesselActivity;
            if (shiploader === shared_1.Shiploader.SHIPLOADER_ONE) {
                shiploader1[key] = Item;
            }
            if (shiploader === shared_1.Shiploader.SHIPLOADER_TWO) {
                shiploader2[key] = Item;
            }
        }
        if (stopVesselActivity || surveyActivity) {
            //This is not shiploader specific
            const Item = vesselActivity;
            shiploader1[key] = Item;
            shiploader2[key] = Item;
        }
    });
    const s1 = SortVesselActivities(shiploader1);
    const s2 = SortVesselActivities(shiploader2);
    const length = shiploader === shared_1.Shiploader.SHIPLOADER_ONE ? s1.length : s2.length;
    let lastActivity = shiploader === shared_1.Shiploader.SHIPLOADER_ONE
        ? s1[s1.length - 1]
        : s2[s2.length - 1];
    if (lastActivity === null || lastActivity === void 0 ? void 0 : lastActivity.vesselHatchActivityGroup) {
        lastActivity.vesselHatchActivityGroup.activities;
        if (Object.values((_b = (_a = lastActivity.vesselHatchActivityGroup) === null || _a === void 0 ? void 0 : _a.activities) !== null && _b !== void 0 ? _b : {})
            .length === 0) {
            lastActivity =
                shiploader === shared_1.Shiploader.SHIPLOADER_ONE
                    ? s1[length - 2]
                    : s2[length - 2];
        }
    }
    return (_d = (_c = lastActivity === null || lastActivity === void 0 ? void 0 : lastActivity.endDate) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : '';
}
exports.getLastVesselActivityEndDate = getLastVesselActivityEndDate;
